module.exports = __webpack_public_path__ + "static/img/ML05.4c4c746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/ML05.jpg
// module id = nJEM
// module chunks = 9